import type { AxiosRequestConfig } from 'axios';
import type { Security, SwaggerResponse } from './config';
import { Http } from './httpRequest';
import {
  deleteOOrgSlugRRestaurantIdBBranchIdIssuesId,
  deleteOOrgSlugRRestaurantIdBBranchIdTransactionsId,
  deleteOOrgSlugRRestaurantIdEmployeeDayOffId,
  deleteOOrgSlugRRestaurantIdEmployeeRulesId,
  deleteOOrgSlugRRestaurantIdEmployeesId,
  deleteOOrgSlugRRestaurantIdEmployeesIdInvited,
  deleteOOrgSlugRRestaurantIdInventoryCategoriesId,
  deleteOOrgSlugRRestaurantIdInventoryItemsId,
  deleteOOrgSlugRRestaurantIdMenuId,
  deleteOOrgSlugRRestaurantIdMenuItemVariantsId,
  deleteOOrgSlugRRestaurantIdMenuItemsId,
  deleteOOrgSlugRRestaurantIdRestaurantBranchesId,
  deleteOOrgSlugRRestaurantIdRestaurantTablesId,
  deleteOOrgSlugRRestaurantIdStorefrontPostsId,
  deleteOOrgSlugRRestaurantIdTransactionCategoriesId,
  getOOrgSlugRRestaurantIdBBranchIdDashboardAccountingReports,
  getOOrgSlugRRestaurantIdBBranchIdDashboardEmployeeIncomes,
  getOOrgSlugRRestaurantIdBBranchIdDashboardInventoryReports,
  getOOrgSlugRRestaurantIdBBranchIdDashboardIssueReports,
  getOOrgSlugRRestaurantIdBBranchIdDashboardSalesReports,
  getOOrgSlugRRestaurantIdBBranchIdDashboardStaffReports,
  getOOrgSlugRRestaurantIdBBranchIdIssues,
  getOOrgSlugRRestaurantIdBBranchIdOrders,
  getOOrgSlugRRestaurantIdBBranchIdOrdersDelivery,
  getOOrgSlugRRestaurantIdBBranchIdOrdersInProgress,
  getOOrgSlugRRestaurantIdBBranchIdOrdersPaidOrderTokens,
  getOOrgSlugRRestaurantIdBBranchIdOrdersRecent,
  getOOrgSlugRRestaurantIdBBranchIdSearch,
  getOOrgSlugRRestaurantIdBBranchIdInventoryMovements,
  getOOrgSlugRRestaurantIdBBranchIdTransactions,
  getOOrgSlugBilling,
  getOOrgSlugIntegrationsZalo,
  getOOrgSlugIntegrationsZaloExport,
  getOOrgSlugRRestaurantIdEmployeeDayOff,
  getOOrgSlugRRestaurantIdEmployeeRules,
  getOOrgSlugRRestaurantIdEmployees,
  getOOrgSlugRRestaurantIdEmployeesMe,
  getOOrgSlugRRestaurantIdEmployeesMeIncomes,
  getOOrgSlugRRestaurantIdInventoryCategories,
  getOOrgSlugRRestaurantIdInventoryItems,
  getOOrgSlugRRestaurantIdInventoryItemsStockLevels,
  getOOrgSlugRRestaurantIdMenu,
  getOOrgSlugRRestaurantIdMenuItemVariants,
  getOOrgSlugRRestaurantIdMenuItems,
  getOOrgSlugRRestaurantIdRestaurantBranches,
  getOOrgSlugRRestaurantIdRestaurantCurrency,
  getOOrgSlugRRestaurantIdRestaurantTables,
  getOOrgSlugRRestaurantIdStorefront,
  getOOrgSlugRRestaurantIdStorefrontBranches,
  getOOrgSlugRRestaurantIdStorefrontMessages,
  getOOrgSlugRRestaurantIdStorefrontPosts,
  getOOrgSlugRRestaurantIdStorefrontSlugAvailable,
  getOOrgSlugRRestaurantIdTransactionCategories,
  getOOrgSlugRestaurants,
  patchOOrgSlugRRestaurantIdEmployeesMeProfile,
  patchOOrgSlugRRestaurantIdBBranchIdIssuesIdPosition,
  patchOOrgSlugRRestaurantIdStorefront,
  patchOOrgSlugRRestaurantIdStorefrontBranchesBranchIdOrdering,
  patchOOrgSlugRRestaurantIdStorefrontMessagesId,
  patchOOrgSlugRRestaurantIdStorefrontPostsId,
  postOOrgSlugRRestaurantIdBBranchIdIssues,
  postOOrgSlugRRestaurantIdBBranchIdOrders,
  postOOrgSlugRRestaurantIdBBranchIdInventoryMovements,
  postOOrgSlugRRestaurantIdBBranchIdTransactions,
  postOOrgSlugRRestaurantIdEmployeeDayOff,
  postOOrgSlugRRestaurantIdEmployeeRules,
  postOOrgSlugRRestaurantIdEmployees,
  postOOrgSlugRRestaurantIdEmployeesIdInvited,
  postOOrgSlugRRestaurantIdInventoryCategories,
  postOOrgSlugRRestaurantIdInventoryItems,
  postOOrgSlugRRestaurantIdMenu,
  postOOrgSlugRRestaurantIdMenuItemVariants,
  postOOrgSlugRRestaurantIdMenuItems,
  postOOrgSlugRRestaurantIdRestaurantBranches,
  postOOrgSlugRRestaurantIdRestaurantTables,
  postOOrgSlugRRestaurantIdStorefrontPosts,
  postOOrgSlugRRestaurantIdStorefrontPreviewLink,
  postOOrgSlugRRestaurantIdStorefrontPublish,
  postOOrgSlugRRestaurantIdStorefrontUnpublish,
  postOOrgSlugRRestaurantIdTransactionCategories,
  postOOrgSlugRestaurants,
  putOOrgSlugIntegrationsZalo,
  putOOrgSlugRRestaurantIdBBranchIdIssuesId,
  putOOrgSlugRRestaurantIdBBranchIdOrdersId,
  putOOrgSlugRRestaurantIdBBranchIdTransactionsId,
  putOOrgSlugRRestaurantIdEmployeeDayOffId,
  putOOrgSlugRRestaurantIdEmployeeRulesId,
  putOOrgSlugRRestaurantIdEmployeesId,
  putOOrgSlugRRestaurantIdInventoryCategoriesId,
  putOOrgSlugRRestaurantIdInventoryItemsId,
  putOOrgSlugRRestaurantIdMenuId,
  putOOrgSlugRRestaurantIdMenuItemVariantsId,
  putOOrgSlugRRestaurantIdMenuItemsId,
  putOOrgSlugRRestaurantIdRestaurantBranchesId,
  putOOrgSlugRRestaurantIdRestaurantTablesId,
  putOOrgSlugRRestaurantIdTransactionCategoriesId,
  putOOrgSlugRestaurantsId,
  template,
  postOOrgSlugBillingCheckout,
  postOOrgSlugBillingPortal,
  deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId,
  deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId,
  deleteOOrgSlugRRestaurantIdEmployeesIdTimesheetPin,
  deleteOOrgSlugRRestaurantIdTimesheetsHolidaysId,
  getOOrgSlugRRestaurantIdBBranchIdTimesheets,
  getOOrgSlugRRestaurantIdBBranchIdTimesheetsCalendar,
  getOOrgSlugRRestaurantIdBBranchIdTimesheetsId,
  getOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskRoster,
  getOOrgSlugRRestaurantIdTimesheetsHolidays,
  getOOrgSlugRRestaurantIdTimesheetsMe,
  getOOrgSlugRRestaurantIdTimesheetsMeCurrent,
  patchOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId,
  patchOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId,
  patchOOrgSlugRRestaurantIdTimesheetsMeEntriesIdNote,
  postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntries,
  postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdBreaks,
  postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdApprove,
  postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdPay,
  postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdReopen,
  postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskConfirm,
  postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskPunch,
  postOOrgSlugRRestaurantIdTimesheetsHolidays,
  postOOrgSlugRRestaurantIdTimesheetsHolidaysLoadVn,
  postOOrgSlugRRestaurantIdTimesheetsMeBreakEnd,
  postOOrgSlugRRestaurantIdTimesheetsMeBreakStart,
  postOOrgSlugRRestaurantIdTimesheetsMeClockIn,
  postOOrgSlugRRestaurantIdTimesheetsMeClockOut,
  postOOrgSlugRRestaurantIdTimesheetsMeIdConfirm,
  putOOrgSlugRRestaurantIdEmployeesIdTimesheetPin,
  deleteOOrgSlugRRestaurantIdBBranchIdSchedulesId,
  deleteOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssignEmployeeId,
  deleteOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister,
  getOOrgSlugRRestaurantIdBBranchIdSchedules,
  getOOrgSlugRRestaurantIdSchedulesMe,
  patchOOrgSlugRRestaurantIdBBranchIdSchedulesId,
  postOOrgSlugRRestaurantIdBBranchIdSchedules,
  postOOrgSlugRRestaurantIdBBranchIdSchedulesCopy,
  postOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssign,
  postOOrgSlugRRestaurantIdBBranchIdSchedulesPublish,
  postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdScheduleLink,
  postOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister,
} from './services';
import type {
  CopyResultDto,
  CopyWeekDto,
  CreateShiftDto,
  EmployeeCreateDto,
  EmployeeDayOffCreateDto,
  EmployeeDayOffEntity,
  EmployeeDayOffUpdateDto,
  EmployeeEntity,
  EmployeeRuleCreateDto,
  EmployeeRuleEntity,
  EmployeeRuleUpdateDto,
  EmployeeSelfProfileDto,
  EmployeeUpdateDto,
  EntryScheduleDto,
  GetManyEmployeeDayOffEntityResponseDto,
  GetManyEmployeeEntityResponseDto,
  GetManyEmployeeRuleEntityResponseDto,
  GetManyInventoryCategoryEntityResponseDto,
  GetManyInventoryItemEntityResponseDto,
  GetManyInventoryMovementEntityResponseDto,
  GetManyIssueEntityResponseDto,
  GetManyMenuItemEntityResponseDto,
  GetManyMenuItemVariantEntityResponseDto,
  GetManyMenuEntityResponseDto,
  GetManyRestaurantBranchEntityResponseDto,
  GetManyRestaurantEntityResponseDto,
  GetManyRestaurantTableEntityResponseDto,
  GetManyStorefrontContactMessageEntityResponseDto,
  GetManyStorefrontPostEntityResponseDto,
  GetManyTransactionCategoryEntityResponseDto,
  GetManyTransactionEntityResponseDto,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardAccountingReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardEmployeeIncomesQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardInventoryReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardIssueReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardSalesReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdDashboardStaffReportsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdIssuesQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdInventoryMovementsQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdOrdersDeliveryQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdOrdersInProgressQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdOrdersQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdOrdersRecentQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdSearchQueryParams,
  GetOOrgSlugRRestaurantIdBBranchIdTransactionsQueryParams,
  GetOOrgSlugRRestaurantIdEmployeeDayOffQueryParams,
  GetOOrgSlugRRestaurantIdEmployeeRulesQueryParams,
  GetOOrgSlugRRestaurantIdEmployeesQueryParams,
  GetOOrgSlugRRestaurantIdMenuItemsQueryParams,
  GetOOrgSlugRRestaurantIdMenuItemVariantsQueryParams,
  GetOOrgSlugRRestaurantIdMenuQueryParams,
  GetOOrgSlugRRestaurantIdInventoryCategoriesQueryParams,
  GetOOrgSlugRRestaurantIdInventoryItemsQueryParams,
  GetOOrgSlugRRestaurantIdInventoryItemsStockLevelsQueryParams,
  GetOOrgSlugRRestaurantIdRestaurantTablesQueryParams,
  GetOOrgSlugRRestaurantIdStorefrontMessagesQueryParams,
  GetOOrgSlugRRestaurantIdStorefrontPostsQueryParams,
  GetOOrgSlugRRestaurantIdTransactionCategoriesQueryParams,
  IssueCreateDto,
  IssueEntity,
  IssuePositionDto,
  IssueUpdateDto,
  InventoryCategoryCreateDto,
  InventoryCategoryEntity,
  InventoryCategoryUpdateDto,
  InventoryItemCreateDto,
  InventoryItemEntity,
  InventoryItemUpdateDto,
  InventoryMovementCreateDto,
  MenuCreateDto,
  MenuEntity,
  MenuItemCreateDto,
  MenuItemEntity,
  MenuItemVariantCreateDto,
  MenuItemVariantEntity,
  MenuItemVariantUpdateDto,
  MenuItemUpdateDto,
  MenuUpdateDto,
  MyScheduleDto,
  OrderCreateDto,
  OrderEntity,
  OrderUpdateDto,
  PublishResultDto,
  PublishWeekDto,
  RestaurantBranchCreateDto,
  RestaurantBranchEntity,
  RestaurantBranchUpdateDto,
  RestaurantCreateDto,
  RestaurantCurrencyDto,
  RestaurantEntity,
  RestaurantStorefrontEntity,
  RestaurantTableCreateDto,
  RestaurantTableEntity,
  RestaurantTableUpdateDto,
  ScheduleListDto,
  ScheduleShiftDto,
  SearchResponseDto,
  StorefrontContactMessageEntity,
  StorefrontMessageUpdateDto,
  StorefrontPostCreateDto,
  StorefrontPostEntity,
  StorefrontBranchOrderingDto,
  StorefrontPostUpdateDto,
  StorefrontPreviewLinkDto,
  StorefrontSlugAvailabilityDto,
  StorefrontUpdateDto,
  TimesheetCalendarDto,
  TransactionCategoryCreateDto,
  TransactionCategoryEntity,
  TransactionCategoryUpdateDto,
  TransactionCreateDto,
  TransactionEntity,
  TransactionUpdateDto,
  UpdateShiftDto,
  ZaloIntegrationReadDto,
  ZaloIntegrationWriteDto,
  BillingCheckoutDto,
  BillingRedirectDto,
  BillingStatusDto,
} from './types';

/**
 * Org-scoped endpoints exist in the generated client with `{orgSlug}` / `{restaurantId}` /
 * `{branchId}` placeholders baked into their `.key`, and codegen does NOT substitute them —
 * the generated functions template only the operation's own `{id}`. This typed layer is the
 * only place that routes a generated `.key` through the generated `template()` helper for the
 * tenant segments before requesting, mirroring the "exact generated call shape" contract
 * (same Http.*Request argument order, security then headers+overrideConfig merge).
 * Hooks must always go through this file, never raw generated fns.
 */

export type OrgScope = { orgSlug: string };
export type RestaurantScope = { orgSlug: string; restaurantId: string };
export type BranchScope = { orgSlug: string; restaurantId: string; branchId: string };

// swag-ts numbers services.ts's shared request constants by first appearance in the OpenAPI
// spec, so a future `bun run gen:swagger` can silently invert what `_CONSTANT0`/`_CONSTANT1`
// mean (it already did once — see the Task 9 fix). This file builds the URL for every
// tenant-scoped request in the portal, so importing those numeric names here would make the
// whole app's routing layer depend on a name assigned by call-site ordering. Defined locally
// instead, values copied from services.ts as of this commit; `Security` on the first one turns
// a future mis-pairing back into a compile error instead of a silent inversion.
const BEARER_SECURITY: Security = [{ bearer: [] }];
const JSON_REQUEST_CONFIG: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

function mergeConfig(config?: AxiosRequestConfig, configOverride?: AxiosRequestConfig): AxiosRequestConfig {
  return {
    ...config,
    ...configOverride,
    headers: {
      ...config?.headers,
      ...configOverride?.headers,
    },
  };
}

/** A bare string is `{ id }`; an object is used as-is — routes whose own path params are not
 *  `id` (codegen leaves `{shiftId}`/`{employeeId}` in `.key`) pass one directly. */
function scopeUrl(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  idOrParams?: string | Record<string, string>
): string {
  if (idOrParams === undefined) return template(key, scope);
  const params = typeof idOrParams === 'string' ? { id: idOrParams } : idOrParams;
  return template(key, { ...scope, ...params });
}

function scopedGet<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  queryParams?: unknown,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.getRequest(
    scopeUrl(key, scope),
    queryParams,
    undefined,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

function scopedPost<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  requestBody: unknown,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.postRequest(
    scopeUrl(key, scope),
    undefined,
    requestBody,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

function scopedPut<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  id: string,
  requestBody: unknown,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.putRequest(
    scopeUrl(key, scope, id),
    undefined,
    requestBody,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

function scopedDelete<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.deleteRequest(
    scopeUrl(key, scope, id),
    undefined,
    undefined,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

function scopedPostWithId<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.postRequest(
    scopeUrl(key, scope, id),
    undefined,
    undefined,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

function scopedPatchWithId<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  id: string,
  requestBody: unknown,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.patchRequest(
    scopeUrl(key, scope, id),
    undefined,
    requestBody,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

function scopedPatch<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  requestBody: unknown,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.patchRequest(
    scopeUrl(key, scope),
    undefined,
    requestBody,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

// Singleton resources (e.g. the one-per-organization Zalo integration) PUT at their own
// scoped path with no trailing `{id}` segment, unlike scopedPut's id-keyed resources.
function scopedPutSingleton<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  requestBody: unknown,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.putRequest(
    scopeUrl(key, scope),
    undefined,
    requestBody,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

// --- Org-level: restaurants & branches --------------------------------------

export function orgRestaurantCreate(
  requestBody: RestaurantCreateDto,
  context: { orgSlug: string },
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRestaurants.key, context, requestBody, configOverride);
}

export function orgRestaurantUpdate(
  id: string,
  requestBody: RestaurantCreateDto,
  context: { orgSlug: string },
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantEntity>> {
  return scopedPut(putOOrgSlugRestaurantsId.key, context, id, requestBody, configOverride);
}

export function orgRestaurants(
  context: { orgSlug: string },
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyRestaurantEntityResponseDto>> {
  return scopedGet(getOOrgSlugRestaurants.key, context, undefined, configOverride);
}

export function orgRestaurantBranchCreate(
  requestBody: RestaurantBranchCreateDto,
  context: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdRestaurantBranches.key, context, requestBody, configOverride);
}

export function orgRestaurantBranchUpdate(
  id: string,
  requestBody: RestaurantBranchUpdateDto,
  context: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdRestaurantBranchesId.key, context, id, requestBody, configOverride);
}

export function orgRestaurantBranchDelete(
  id: string,
  context: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdRestaurantBranchesId.key, context, id, configOverride);
}

export function orgRestaurantBranches(
  context: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyRestaurantBranchEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdRestaurantBranches.key, context, undefined, configOverride);
}

// Member-readable (unlike orgRestaurants, owner/admin only) — POS/Kitchen/Delivery/`me` read
// the current restaurant's currency through this instead. See useMoney.
export function tenantRestaurantCurrency(
  context: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantCurrencyDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdRestaurantCurrency.key, context, undefined, configOverride);
}

// --- Org-level: integrations -------------------------------------------------

export function orgZaloIntegration(
  context: OrgScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloIntegrationReadDto>> {
  return scopedGet(getOOrgSlugIntegrationsZalo.key, context, undefined, configOverride);
}

export function orgZaloIntegrationUpdate(
  requestBody: ZaloIntegrationWriteDto,
  context: OrgScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<ZaloIntegrationReadDto>> {
  return scopedPutSingleton(putOOrgSlugIntegrationsZalo.key, context, requestBody, configOverride);
}

// The Mini App's build-time config (apps/zalo-mini/src/restavo-config.json). Swagger types
// this response as `any` — the controller returns a plain object, not a DTO class — so the
// only caller serializes it straight to a file rather than reading fields off it.
export function orgZaloIntegrationExport(
  context: OrgScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedGet(getOOrgSlugIntegrationsZaloExport.key, context, undefined, configOverride);
}

// --- Org-level: billing -----------------------------------------------------

export function orgBilling(
  context: OrgScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<BillingStatusDto>> {
  return scopedGet(getOOrgSlugBilling.key, context, undefined, configOverride);
}

export function orgBillingCheckout(
  requestBody: BillingCheckoutDto,
  context: OrgScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<BillingRedirectDto>> {
  return scopedPost(postOOrgSlugBillingCheckout.key, context, requestBody, configOverride);
}

export function orgBillingPortal(
  context: OrgScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<BillingRedirectDto>> {
  return scopedPost(postOOrgSlugBillingPortal.key, context, {}, configOverride);
}

// --- Restaurant-level resources ---------------------------------------------

export function tenantMenu(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdMenuQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyMenuEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdMenu.key, scope, queryParams, configOverride);
}

export function tenantMenuCreate(
  scope: RestaurantScope,
  requestBody: MenuCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdMenu.key, scope, requestBody, configOverride);
}

export function tenantMenuUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: MenuUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdMenuId.key, scope, id, requestBody, configOverride);
}

export function tenantMenuDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdMenuId.key, scope, id, configOverride);
}

export function tenantMenuItems(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdMenuItemsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyMenuItemEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdMenuItems.key, scope, queryParams, configOverride);
}

export function tenantMenuItemCreate(
  scope: RestaurantScope,
  requestBody: MenuItemCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdMenuItems.key, scope, requestBody, configOverride);
}

export function tenantMenuItemUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: MenuItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdMenuItemsId.key, scope, id, requestBody, configOverride);
}

export function tenantMenuItemDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdMenuItemsId.key, scope, id, configOverride);
}

export function tenantMenuItemVariants(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdMenuItemVariantsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyMenuItemVariantEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdMenuItemVariants.key, scope, queryParams, configOverride);
}

export function tenantMenuItemVariantCreate(
  scope: RestaurantScope,
  requestBody: MenuItemVariantCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdMenuItemVariants.key, scope, requestBody, configOverride);
}

export function tenantMenuItemVariantUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: MenuItemVariantUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<MenuItemVariantEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdMenuItemVariantsId.key, scope, id, requestBody, configOverride);
}

export function tenantMenuItemVariantDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdMenuItemVariantsId.key, scope, id, configOverride);
}

export function tenantEmployees(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdEmployeesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyEmployeeEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdEmployees.key, scope, queryParams, configOverride);
}

export function tenantEmployeeCreate(
  scope: RestaurantScope,
  requestBody: EmployeeCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdEmployees.key, scope, requestBody, configOverride);
}

export function tenantEmployeeUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: EmployeeUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdEmployeesId.key, scope, id, requestBody, configOverride);
}

export function tenantEmployeeDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdEmployeesId.key, scope, id, configOverride);
}

export function tenantEmployeeMarkInvited(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> {
  return scopedPostWithId(postOOrgSlugRRestaurantIdEmployeesIdInvited.key, scope, id, configOverride);
}

export function tenantEmployeeClearInvited(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdEmployeesIdInvited.key, scope, id, configOverride);
}

/**
 * The caller's OWN employment record for the restaurant in scope. The server resolves the
 * employee id from the session (SelfEmployeeGuard) — nothing identifying travels from here —
 * and answers 403 `NOT_AN_EMPLOYEE` when the caller was never hired.
 */
export function tenantEmployeeMe(
  scope: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> {
  return scopedGet(getOOrgSlugRRestaurantIdEmployeesMe.key, scope, undefined, configOverride);
}

/**
 * The caller's own income report. The server route carries no `@ApiResponse` type (the
 * owner-facing `dashboard/employee-incomes` route doesn't either — typing it needs a response
 * DTO for an object DashboardService builds inline), so codegen emits `SwaggerResponse<any>`
 * for it. Rather than leak that `any`, the caller names the shape it expects:
 * `useSelfEmployee` passes `SelfEmployeeIncomes`. Keep `T` explicit at every call site.
 */
export function tenantEmployeeMyIncomes<T = unknown>(
  scope: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return scopedGet<T>(getOOrgSlugRRestaurantIdEmployeesMeIncomes.key, scope, undefined, configOverride);
}

/**
 * Self-service edit of the one contact field the portal owns. Name, email and avatar are
 * apps/auth-owned and flow inbound via the provisioning webhook, so they are not accepted here.
 */
export function tenantEmployeeUpdateMyProfile(
  scope: RestaurantScope,
  requestBody: EmployeeSelfProfileDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeEntity>> {
  return scopedPatch(patchOOrgSlugRRestaurantIdEmployeesMeProfile.key, scope, requestBody, configOverride);
}

export function tenantEmployeeRules(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdEmployeeRulesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyEmployeeRuleEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdEmployeeRules.key, scope, queryParams, configOverride);
}

export function tenantEmployeeRuleCreate(
  scope: RestaurantScope,
  requestBody: EmployeeRuleCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdEmployeeRules.key, scope, requestBody, configOverride);
}

export function tenantEmployeeRuleUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: EmployeeRuleUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeRuleEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdEmployeeRulesId.key, scope, id, requestBody, configOverride);
}

export function tenantEmployeeRuleDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdEmployeeRulesId.key, scope, id, configOverride);
}

export function tenantEmployeeDayOff(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdEmployeeDayOffQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyEmployeeDayOffEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdEmployeeDayOff.key, scope, queryParams, configOverride);
}

export function tenantEmployeeDayOffCreate(
  scope: RestaurantScope,
  requestBody: EmployeeDayOffCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdEmployeeDayOff.key, scope, requestBody, configOverride);
}

export function tenantEmployeeDayOffUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: EmployeeDayOffUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<EmployeeDayOffEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdEmployeeDayOffId.key, scope, id, requestBody, configOverride);
}

export function tenantEmployeeDayOffDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdEmployeeDayOffId.key, scope, id, configOverride);
}

export function tenantTables(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdRestaurantTablesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyRestaurantTableEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdRestaurantTables.key, scope, queryParams, configOverride);
}

export function tenantTableCreate(
  scope: RestaurantScope,
  requestBody: RestaurantTableCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdRestaurantTables.key, scope, requestBody, configOverride);
}

export function tenantTableUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: RestaurantTableUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantTableEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdRestaurantTablesId.key, scope, id, requestBody, configOverride);
}

export function tenantTableDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdRestaurantTablesId.key, scope, id, configOverride);
}

export function tenantTransactionCategories(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdTransactionCategoriesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyTransactionCategoryEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdTransactionCategories.key, scope, queryParams, configOverride);
}

export function tenantTransactionCategoryCreate(
  scope: RestaurantScope,
  requestBody: TransactionCategoryCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdTransactionCategories.key, scope, requestBody, configOverride);
}

export function tenantTransactionCategoryUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: TransactionCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionCategoryEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdTransactionCategoriesId.key, scope, id, requestBody, configOverride);
}

export function tenantTransactionCategoryDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdTransactionCategoriesId.key, scope, id, configOverride);
}

export function tenantInventoryItems(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdInventoryItemsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyInventoryItemEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdInventoryItems.key, scope, queryParams, configOverride);
}

export function tenantInventoryItemCreate(
  scope: RestaurantScope,
  requestBody: InventoryItemCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdInventoryItems.key, scope, requestBody, configOverride);
}

export function tenantInventoryItemUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: InventoryItemUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryItemEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdInventoryItemsId.key, scope, id, requestBody, configOverride);
}

export function tenantInventoryItemDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdInventoryItemsId.key, scope, id, configOverride);
}

export function tenantInventoryStockLevels(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdInventoryItemsStockLevelsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<Array<{ itemId: string; branchId: string | null; quantity: number }>>> {
  return scopedGet(getOOrgSlugRRestaurantIdInventoryItemsStockLevels.key, scope, queryParams, configOverride);
}

export function tenantInventoryCategories(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdInventoryCategoriesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyInventoryCategoryEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdInventoryCategories.key, scope, queryParams, configOverride);
}

export function tenantInventoryCategoryCreate(
  scope: RestaurantScope,
  requestBody: InventoryCategoryCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdInventoryCategories.key, scope, requestBody, configOverride);
}

export function tenantInventoryCategoryUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: InventoryCategoryUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<InventoryCategoryEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdInventoryCategoriesId.key, scope, id, requestBody, configOverride);
}

export function tenantInventoryCategoryDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdInventoryCategoriesId.key, scope, id, configOverride);
}

// --- Restaurant-level: storefront -------------------------------------------

export function tenantStorefront(
  scope: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> {
  return scopedGet(getOOrgSlugRRestaurantIdStorefront.key, scope, undefined, configOverride);
}

export function tenantStorefrontUpdate(
  scope: RestaurantScope,
  requestBody: StorefrontUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> {
  return scopedPatch(patchOOrgSlugRRestaurantIdStorefront.key, scope, requestBody, configOverride);
}

export function tenantStorefrontSlugAvailable(
  scope: RestaurantScope,
  slug: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontSlugAvailabilityDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdStorefrontSlugAvailable.key, scope, { slug }, configOverride);
}

export function tenantStorefrontPublish(
  scope: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> {
  return scopedPost(postOOrgSlugRRestaurantIdStorefrontPublish.key, scope, undefined, configOverride);
}

export function tenantStorefrontUnpublish(
  scope: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantStorefrontEntity>> {
  return scopedPost(postOOrgSlugRRestaurantIdStorefrontUnpublish.key, scope, undefined, configOverride);
}

export function tenantStorefrontPreviewLink(
  scope: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontPreviewLinkDto>> {
  return scopedPost(postOOrgSlugRRestaurantIdStorefrontPreviewLink.key, scope, undefined, configOverride);
}

export function tenantStorefrontBranches(
  scope: RestaurantScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity[]>> {
  return scopedGet(getOOrgSlugRRestaurantIdStorefrontBranches.key, scope, undefined, configOverride);
}

export function tenantStorefrontBranchOrdering(
  scope: RestaurantScope,
  branchId: string,
  requestBody: StorefrontBranchOrderingDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<RestaurantBranchEntity>> {
  return scopedPatchWithId(
    patchOOrgSlugRRestaurantIdStorefrontBranchesBranchIdOrdering.key,
    scope,
    branchId,
    requestBody,
    configOverride
  );
}

export function tenantStorefrontPosts(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdStorefrontPostsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyStorefrontPostEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdStorefrontPosts.key, scope, queryParams, configOverride);
}

export function tenantStorefrontPostCreate(
  scope: RestaurantScope,
  requestBody: StorefrontPostCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdStorefrontPosts.key, scope, requestBody, configOverride);
}

export function tenantStorefrontPostUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: StorefrontPostUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontPostEntity>> {
  return scopedPatchWithId(patchOOrgSlugRRestaurantIdStorefrontPostsId.key, scope, id, requestBody, configOverride);
}

export function tenantStorefrontPostDelete(
  scope: RestaurantScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdStorefrontPostsId.key, scope, id, configOverride);
}

export function tenantStorefrontMessages(
  scope: RestaurantScope,
  queryParams?: GetOOrgSlugRRestaurantIdStorefrontMessagesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyStorefrontContactMessageEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdStorefrontMessages.key, scope, queryParams, configOverride);
}

export function tenantStorefrontMessageUpdate(
  scope: RestaurantScope,
  id: string,
  requestBody: StorefrontMessageUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<StorefrontContactMessageEntity>> {
  return scopedPatchWithId(patchOOrgSlugRRestaurantIdStorefrontMessagesId.key, scope, id, requestBody, configOverride);
}

// --- Branch-level resources --------------------------------------------------

export function tenantOrders(
  scope: BranchScope,
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdOrdersQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdOrders.key, scope, queryParams, configOverride);
}

export function tenantOrdersDelivery(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdOrdersDeliveryQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdOrdersDelivery.key, scope, queryParams, configOverride);
}

export function tenantOrdersRecent(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdOrdersRecentQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdOrdersRecent.key, scope, queryParams, configOverride);
}

export function tenantOrdersInProgress(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdOrdersInProgressQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<{ data?: OrderEntity[]; limit?: number; page?: number; total?: number }>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdOrdersInProgress.key, scope, queryParams, configOverride);
}

export function tenantPaidOrderTokens(
  scope: BranchScope,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<string[]>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdOrdersPaidOrderTokens.key, scope, undefined, configOverride);
}

export function tenantOrderCreate(
  scope: BranchScope,
  requestBody: OrderCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdBBranchIdOrders.key, scope, requestBody, configOverride);
}

export function tenantOrderUpdate(
  scope: BranchScope,
  id: string,
  requestBody: OrderUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPut(putOOrgSlugRRestaurantIdBBranchIdOrdersId.key, scope, id, requestBody, configOverride);
}

export function tenantIssues(
  scope: BranchScope,
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdIssuesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyIssueEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdIssues.key, scope, queryParams, configOverride);
}

export function tenantIssueCreate(
  scope: BranchScope,
  requestBody: IssueCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdBBranchIdIssues.key, scope, requestBody, configOverride);
}

export function tenantIssueUpdate(
  scope: BranchScope,
  id: string,
  requestBody: IssueUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdBBranchIdIssuesId.key, scope, id, requestBody, configOverride);
}

export function tenantIssuePosition(
  scope: BranchScope,
  id: string,
  requestBody: IssuePositionDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<IssueEntity>> {
  return scopedPatchWithId(
    patchOOrgSlugRRestaurantIdBBranchIdIssuesIdPosition.key,
    scope,
    id,
    requestBody,
    configOverride
  );
}

export function tenantIssueDelete(
  scope: BranchScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdBBranchIdIssuesId.key, scope, id, configOverride);
}

export function tenantTransactions(
  scope: BranchScope,
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdTransactionsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyTransactionEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdTransactions.key, scope, queryParams, configOverride);
}

export function tenantTransactionCreate(
  scope: BranchScope,
  requestBody: TransactionCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdBBranchIdTransactions.key, scope, requestBody, configOverride);
}

export function tenantTransactionUpdate(
  scope: BranchScope,
  id: string,
  requestBody: TransactionUpdateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<TransactionEntity>> {
  return scopedPut(putOOrgSlugRRestaurantIdBBranchIdTransactionsId.key, scope, id, requestBody, configOverride);
}

export function tenantTransactionDelete(
  scope: BranchScope,
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedDelete(deleteOOrgSlugRRestaurantIdBBranchIdTransactionsId.key, scope, id, configOverride);
}

export function tenantDashboardSalesReports(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardSalesReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdDashboardSalesReports.key, scope, queryParams, configOverride);
}

export function tenantDashboardAccountingReports(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardAccountingReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdDashboardAccountingReports.key, scope, queryParams, configOverride);
}

export function tenantDashboardEmployeeIncomes(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardEmployeeIncomesQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdDashboardEmployeeIncomes.key, scope, queryParams, configOverride);
}

export function tenantInventoryMovements(
  scope: BranchScope,
  queryParams?: GetOOrgSlugRRestaurantIdBBranchIdInventoryMovementsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<GetManyInventoryMovementEntityResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdInventoryMovements.key, scope, queryParams, configOverride);
}

export function tenantInventoryMovementCreate(
  scope: BranchScope,
  requestBody: InventoryMovementCreateDto,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedPost(postOOrgSlugRRestaurantIdBBranchIdInventoryMovements.key, scope, requestBody, configOverride);
}

export function tenantDashboardInventoryReports(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardInventoryReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdDashboardInventoryReports.key, scope, queryParams, configOverride);
}

export function tenantDashboardStaffReports(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardStaffReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdDashboardStaffReports.key, scope, queryParams, configOverride);
}

export function tenantDashboardIssueReports(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdDashboardIssueReportsQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<any>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdDashboardIssueReports.key, scope, queryParams, configOverride);
}

export function tenantSearch(
  scope: BranchScope,
  queryParams: GetOOrgSlugRRestaurantIdBBranchIdSearchQueryParams,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<SearchResponseDto>> {
  return scopedGet(getOOrgSlugRRestaurantIdBBranchIdSearch.key, scope, queryParams, configOverride);
}

// ---- Timesheets (spec 2026-09-26). Responses are typed in src/hooks/useTimesheets.ts: the
// server's hand-written controllers return assembled objects that carry no @ApiResponse. ----

function scopedGetWithId<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  id: string,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.getRequest(
    scopeUrl(key, scope, id),
    undefined,
    undefined,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

function scopedPostWithIdBody<T>(
  key: string,
  scope: { orgSlug: string; restaurantId?: string; branchId?: string },
  id: string,
  requestBody: unknown,
  configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<T>> {
  return Http.postRequest(
    scopeUrl(key, scope, id),
    undefined,
    requestBody,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG, configOverride)
  );
}

export const timesheetMeCurrent = (scope: RestaurantScope) =>
  scopedGet(getOOrgSlugRRestaurantIdTimesheetsMeCurrent.key, scope, undefined);
export const timesheetMeClockIn = (
  scope: RestaurantScope,
  body: { shiftName?: string; note?: string; lat?: number; lng?: number }
) => scopedPost(postOOrgSlugRRestaurantIdTimesheetsMeClockIn.key, scope, body);
export const timesheetMeClockOut = (scope: RestaurantScope) =>
  scopedPost(postOOrgSlugRRestaurantIdTimesheetsMeClockOut.key, scope, {});
export const timesheetMeBreakStart = (scope: RestaurantScope, paid: boolean) =>
  scopedPost(postOOrgSlugRRestaurantIdTimesheetsMeBreakStart.key, scope, { paid });
export const timesheetMeBreakEnd = (scope: RestaurantScope) =>
  scopedPost(postOOrgSlugRRestaurantIdTimesheetsMeBreakEnd.key, scope, {});
export const timesheetMeRange = (scope: RestaurantScope, from: string, to: string) =>
  scopedGet(getOOrgSlugRRestaurantIdTimesheetsMe.key, scope, { from, to });
export const timesheetMeConfirm = (scope: RestaurantScope, id: string) =>
  scopedPostWithId(postOOrgSlugRRestaurantIdTimesheetsMeIdConfirm.key, scope, id);
export const timesheetMeNote = (scope: RestaurantScope, entryId: string, employeeNote: string | null) =>
  scopedPatchWithId(patchOOrgSlugRRestaurantIdTimesheetsMeEntriesIdNote.key, scope, entryId, { employeeNote });

export const timesheetKioskRoster = (scope: BranchScope) =>
  scopedGet(getOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskRoster.key, scope, undefined);
export const timesheetKioskPunch = (
  scope: BranchScope,
  body: {
    employeeId: string;
    pin: string;
    action: 'IN' | 'OUT' | 'BREAK_START' | 'BREAK_END';
    shiftName?: string;
    paid?: boolean;
  }
) => scopedPost(postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskPunch.key, scope, body);
export const timesheetKioskConfirm = (
  scope: BranchScope,
  body: { employeeId: string; pin: string; timesheetId: string }
) => scopedPost(postOOrgSlugRRestaurantIdBBranchIdTimesheetsKioskConfirm.key, scope, body);

export const timesheetList = (scope: BranchScope, date: string) =>
  scopedGet(getOOrgSlugRRestaurantIdBBranchIdTimesheets.key, scope, { date });
export const timesheetCalendar = (scope: BranchScope, from: string, to: string) =>
  scopedGet<TimesheetCalendarDto>(getOOrgSlugRRestaurantIdBBranchIdTimesheetsCalendar.key, scope, { from, to });
export const timesheetGet = (scope: BranchScope, id: string) =>
  scopedGetWithId(getOOrgSlugRRestaurantIdBBranchIdTimesheetsId.key, scope, id);
export const timesheetEntryCreate = (
  scope: BranchScope,
  body: { employeeId: string; clockInAt: string; clockOutAt: string; shiftName?: string; note?: string }
) => scopedPost(postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntries.key, scope, body);
export const timesheetEntryUpdate = (
  scope: BranchScope,
  id: string,
  body: { clockInAt?: string; clockOutAt?: string; shiftName?: string | null; note?: string | null }
) => scopedPatchWithId(patchOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId.key, scope, id, body);
export const timesheetEntryDelete = (scope: BranchScope, id: string) =>
  scopedDelete(deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesId.key, scope, id);
export const timesheetBreakCreate = (
  scope: BranchScope,
  entryId: string,
  body: { startAt: string; endAt: string; paid: boolean }
) => scopedPostWithIdBody(postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdBreaks.key, scope, entryId, body);
export const timesheetBreakUpdate = (
  scope: BranchScope,
  id: string,
  body: { startAt?: string; endAt?: string; paid?: boolean }
) => scopedPatchWithId(patchOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId.key, scope, id, body);
export const timesheetBreakDelete = (scope: BranchScope, id: string) =>
  scopedDelete(deleteOOrgSlugRRestaurantIdBBranchIdTimesheetsBreaksId.key, scope, id);
export const timesheetApprove = (scope: BranchScope, id: string) =>
  scopedPostWithId(postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdApprove.key, scope, id);
export const timesheetReopen = (scope: BranchScope, id: string, reason: string) =>
  scopedPostWithIdBody(postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdReopen.key, scope, id, { reason });
export const timesheetPay = (
  scope: BranchScope,
  id: string,
  body: { paidAt: string; method: 'CASH' | 'TRANSFER' | 'OTHER'; categoryId?: string | null }
) => scopedPostWithIdBody(postOOrgSlugRRestaurantIdBBranchIdTimesheetsIdPay.key, scope, id, body);

export const timesheetPinSet = (scope: RestaurantScope, employeeId: string, pin: string) =>
  scopedPut(putOOrgSlugRRestaurantIdEmployeesIdTimesheetPin.key, scope, employeeId, { pin });
export const timesheetPinClear = (scope: RestaurantScope, employeeId: string) =>
  scopedDelete(deleteOOrgSlugRRestaurantIdEmployeesIdTimesheetPin.key, scope, employeeId);

export const timesheetHolidays = (scope: RestaurantScope) =>
  scopedGet(getOOrgSlugRRestaurantIdTimesheetsHolidays.key, scope, undefined);
export const timesheetHolidayCreate = (scope: RestaurantScope, body: { date: string; name: string }) =>
  scopedPost(postOOrgSlugRRestaurantIdTimesheetsHolidays.key, scope, body);
export const timesheetHolidayDelete = (scope: RestaurantScope, id: string) =>
  scopedDelete(deleteOOrgSlugRRestaurantIdTimesheetsHolidaysId.key, scope, id);
export const timesheetHolidaysLoadVn = (scope: RestaurantScope, year: number) =>
  scopedPost(postOOrgSlugRRestaurantIdTimesheetsHolidaysLoadVn.key, scope, { year });

// --- Shift scheduling (spec 2026-09-27) ----------------------------------------

export const scheduleList = (scope: BranchScope, from: string, to: string) =>
  scopedGet<ScheduleListDto>(getOOrgSlugRRestaurantIdBBranchIdSchedules.key, scope, { from, to });
export const scheduleCreate = (scope: BranchScope, body: CreateShiftDto) =>
  scopedPost<ScheduleShiftDto>(postOOrgSlugRRestaurantIdBBranchIdSchedules.key, scope, body);
export const scheduleUpdate = (scope: BranchScope, id: string, body: UpdateShiftDto) =>
  scopedPatchWithId<ScheduleShiftDto>(patchOOrgSlugRRestaurantIdBBranchIdSchedulesId.key, scope, id, body);
export const scheduleDelete = (scope: BranchScope, id: string) =>
  scopedDelete(deleteOOrgSlugRRestaurantIdBBranchIdSchedulesId.key, scope, id);
export const scheduleAssign = (scope: BranchScope, id: string, employeeId: string) =>
  scopedPostWithIdBody<ScheduleShiftDto>(postOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssign.key, scope, id, {
    employeeId,
  });
export const scheduleUnassign = (scope: BranchScope, id: string, employeeId: string) =>
  Http.deleteRequest(
    scopeUrl(deleteOOrgSlugRRestaurantIdBBranchIdSchedulesIdAssignEmployeeId.key, scope, { id, employeeId }),
    undefined,
    undefined,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG)
  );
export const schedulePublish = (scope: BranchScope, body: PublishWeekDto) =>
  scopedPost<PublishResultDto>(postOOrgSlugRRestaurantIdBBranchIdSchedulesPublish.key, scope, body);
export const scheduleCopy = (scope: BranchScope, body: CopyWeekDto) =>
  scopedPost<CopyResultDto>(postOOrgSlugRRestaurantIdBBranchIdSchedulesCopy.key, scope, body);
export const scheduleMine = (scope: RestaurantScope, from: string, to: string) =>
  scopedGet<MyScheduleDto>(getOOrgSlugRRestaurantIdSchedulesMe.key, scope, { from, to });
export const scheduleRegister = (scope: RestaurantScope, shiftId: string) =>
  Http.postRequest(
    scopeUrl(postOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister.key, scope, { shiftId }),
    undefined,
    {},
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG)
  );
export const scheduleWithdraw = (scope: RestaurantScope, shiftId: string) =>
  Http.deleteRequest(
    scopeUrl(deleteOOrgSlugRRestaurantIdSchedulesMeShiftIdRegister.key, scope, { shiftId }),
    undefined,
    undefined,
    BEARER_SECURITY,
    mergeConfig(JSON_REQUEST_CONFIG)
  );
export const timesheetEntryScheduleLink = (scope: BranchScope, entryId: string, assignmentId: string | null) =>
  scopedPostWithIdBody<EntryScheduleDto>(
    postOOrgSlugRRestaurantIdBBranchIdTimesheetsEntriesIdScheduleLink.key,
    scope,
    entryId,
    { assignmentId }
  );
